import { render, staticRenderFns } from "./ItemFactorSetting.vue?vue&type=template&id=9624f68a&scoped=true"
import script from "./ItemFactorSetting.vue?vue&type=script&lang=js"
export * from "./ItemFactorSetting.vue?vue&type=script&lang=js"
import style0 from "./ItemFactorSetting.vue?vue&type=style&index=0&id=9624f68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9624f68a",
  null
  
)

export default component.exports